import React, { useCallback, useReducer } from 'react';
import { CreateGameDeveloperActionTypes } from '../createDeveloperModalActions';
import { createGameDeveloperReducer } from './createDeveloperModalReducer';
import {
	createGameDeveloperInitialState,
	CreateGameDeveloperContext,
	TTypeOfCreateGameDeveloperModalWindow,
} from './createDeveloperModalContext';
import { ICreateGameDeveloper } from 'types';

const CreateGameDeveloperState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createGameDeveloperReducer, createGameDeveloperInitialState);

	const changeName = useCallback((value: string) => {
		dispatch({
			type: CreateGameDeveloperActionTypes.CHANGE_NAME,
			payload: {
				name: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: ICreateGameDeveloper | null) => {
		dispatch({
			type: CreateGameDeveloperActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfCreateGameDeveloperModalWindow) => {
		dispatch({
			type: CreateGameDeveloperActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateGameDeveloperActionTypes.RESET_FIELDS }), []);

	return (
		<CreateGameDeveloperContext.Provider
			value={{
				changeName,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				name: state.name,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateGameDeveloperContext.Provider>
	);
};

export default React.memo(CreateGameDeveloperState);
